export const LAUNCH_STATES = {
  PREPARING: {
    id: "1",
    value: "PREPARING",
    name: "Preparing",
    color: "#A78DC2",
  },
  INTRODUCED: {
    id: "2",
    value: "INTRODUCED",
    name: "Introduced",
    color: "#0FC398",
  },
  LAUNCHED: {
    id: "3",
    value: "LAUNCHED",
    name: "Launched",
    color: "red",
  },
};

// STEPS titles are wrapped at the consumer (ProductLaunchForm.jsx) before being
// passed to FormWizard, which renders step.title directly. FormWizard is shared
// across modules and we don't refactor it here.
const STEPS = [
  {
    titleKey: ($) => $.merchandising["Launch Setup"],
    validations: ["name"],
  },
  {
    titleKey: ($) => $.merchandising["Select Products"],
    validations: ["category", "products", "landedCost"],
  },
  {
    titleKey: ($) => $.merchandising["Launch Goals"],
    validations: ["goals", "exitCriteria", "budget", "startDate", "duration"],
  },
];

const LAUNCH_DURATION_OPTIONS = [
  { label: ($) => $.merchandising["# days"], count: 30, value: 30 },
  { label: ($) => $.merchandising["# days"], count: 60, value: 60 },
  { label: ($) => $.merchandising["# days"], count: 90, value: 90 },
  { label: ($) => $.merchandising["# days"], count: 120, value: 120 },
  { label: ($) => $.merchandising["# days"], count: 150, value: 150 },
  { label: ($) => $.merchandising["# days"], count: 180, value: 180 },
];

const EXIT_CRITERIA_MAP = [
  {
    label: ($) => $.merchandising["Sales"],
    stateName: "sales",
    format: "currency",
    defaultChecked: true,
    defaultValue: 1000,
  },
  {
    label: ($) => $.merchandising["Units"],
    stateName: "units",
    format: "number",
    defaultChecked: true,
    defaultValue: 100,
  },
  {
    label: ($) => $.merchandising["# of Ratings"],
    stateName: "numOfRatings",
    format: "number",
    defaultChecked: true,
    defaultValue: 10,
  },
];

const GOALS_MAP = [
  {
    label: ($) => $.merchandising["Margin"],
    stateName: "margin",
    format: "percent",
    defaultChecked: true,
    defaultValue: 20,
  },
  {
    label: ($) => $.merchandising["Max ACOS"],
    stateName: "acos",
    format: "percent",
    defaultChecked: true,
    defaultValue: 40,
  },
  {
    label: ($) => $.merchandising["Minimum Rating"],
    stateName: "minRating",
    format: "number",
    defaultChecked: true,
    defaultValue: 3.5,
  },
];

const BUDGET_MAP = [
  {
    label: ($) => $.merchandising["Advertising"],
    stateName: "advertising",
    format: "currency",
    defaultChecked: true,
    defaultValue: 10,
  },
];

const DEFAULT_GOALS = {};
const DEFAULT_BUDGET = {};
const DEFAULT_EXIT_CRITERIA = {};

GOALS_MAP.forEach((goal) => {
  DEFAULT_GOALS[goal.stateName] = {
    checked: goal.defaultChecked,
    value: goal.defaultValue,
  };
});

BUDGET_MAP.forEach((budget) => {
  DEFAULT_BUDGET[budget.stateName] = {
    checked: budget.defaultChecked,
    value: budget.defaultValue,
  };
});

EXIT_CRITERIA_MAP.forEach((criteria) => {
  DEFAULT_EXIT_CRITERIA[criteria.stateName] = {
    checked: criteria.defaultChecked,
    value: criteria.defaultValue,
  };
});

export {
  STEPS,
  DEFAULT_GOALS,
  DEFAULT_BUDGET,
  DEFAULT_EXIT_CRITERIA,
  GOALS_MAP,
  BUDGET_MAP,
  EXIT_CRITERIA_MAP,
  LAUNCH_DURATION_OPTIONS,
};
